import { render } from "./DropdownEditPageStrategy.vue?vue&type=template&id=2f6f63c4&scoped=true"
import script from "./DropdownEditPageStrategy.vue?vue&type=script&lang=js"
export * from "./DropdownEditPageStrategy.vue?vue&type=script&lang=js"

import "./DropdownEditPageStrategy.vue?vue&type=style&index=0&id=2f6f63c4&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2f6f63c4"

export default script